import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import {
  selectGenres,
  homepageActions,
  selectGenresLoading,
} from "../../saga/homepageSlice";
import {
  Box,
  Button,
  CircularProgress,
  Collapse,
  Grid,
  Skeleton,
  Typography,
} from "@mui/material";
import CategoryCard from "../../components/CategoryCard";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { searchStoreActions } from "features/searchStore/saga/searchStoreSlice";
import { useNavigate } from "react-router-dom";

export function MSearchByGenre() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const genreList = useAppSelector(selectGenres);
  const isLoading = useAppSelector(selectGenresLoading);

  const [seeMore, setSeeMore] = useState(false);

  const topGenre = genreList.slice(0, 6);
  const subGenre = genreList.slice(6);

  const handleOnClick = (e: any) => {
    const prev = seeMore;
    setSeeMore(!prev);
  };

  const handleClickCard = (e: any) => {
    dispatch(searchStoreActions.setSingleGenre(e));
    navigate("/stores");
  };

  useEffect(() => {
    dispatch(homepageActions.getFoodGenres(6));
  }, [dispatch]);

  if (genreList.length === 0) {
    return (
      <Box
        my={2}
        bgcolor="white"
        borderBottom={1}
        borderTop={1}
        borderColor="divider"
      >
        <Typography variant="h5" fontWeight="bold" sx={{ p: 2 }}>
          料理ジャンルから探す
        </Typography>

        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          my={2}
          p={3}
        >
          {isLoading ? (
            <Box
              p={1}
              display="flex"
              alignItems="center"
              justifyContent="center"
              height="300px"
            >
              <CircularProgress />
            </Box>
          ) : (
            <Typography variant="h6">料理ジャンルリストは空です</Typography>
          )}
        </Box>
      </Box>
    );
  }

  return (
    <Box
      my={2}
      bgcolor="white"
      borderBottom={1}
      borderTop={1}
      borderColor="divider"
    >
      <Typography variant="h5" fontWeight="bold" sx={{ p: 2 }}>
        料理ジャンルから探す
      </Typography>

      <Grid container rowGap={2} sx={{ my: 2 }}>
        {isLoading ? (
          <Grid
            item
            xs={12}
            p={1}
            display="flex"
            alignItems="center"
            justifyContent="center"
            height="300px"
          >
            <CircularProgress />
          </Grid>
        ) : (
          topGenre.map((e) => (
            <Grid
              key={e.Id}
              xs={6}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <CategoryCard
                id={e.Id}
                bgImg={e.Images}
                title={e.Name}
                storeNum={e.StoreCount}
                description={e.Description}
                handleClick={handleClickCard}
              />
            </Grid>
          ))
        )}
      </Grid>

      {subGenre && (
        <Box px={2}>
          <Box display="flex" width="100%" justifyContent="end">
            <Button
              endIcon={seeMore ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
              sx={{
                textTransform: "none",
              }}
              onClick={handleOnClick}
            >
              {seeMore ? "たたむ" : "もっとみる"}
            </Button>
          </Box>
          <Collapse in={seeMore}>
            <Box display="flex" flexWrap="wrap">
              {subGenre.map((e) => (
                <Box
                  key={e.Id}
                  border={1}
                  borderRadius={1}
                  borderColor="divider"
                  width="max-content"
                  sx={{
                    padding: 1,
                    marginRight: 2,
                    my: 2,
                    "&:hover": {
                      cursor: "pointer",
                      color: "primary.main",
                      bordercolor: "primary.main",
                    },
                  }}
                  onClick={() => handleClickCard(e.Id)}
                >
                  <Typography variant="subtitle2">{e.Name}</Typography>
                </Box>
              ))}
            </Box>
          </Collapse>
        </Box>
      )}
    </Box>
  );
}
